export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14209.f47b8619.jpg";